import Home from "../pages/Home";
import UserRegisterForm from "../components/RegisterUserForm";
import CorbansTable from "../components/CorbansTable";
import CreateCorbanPage from "@/pages/CreateCorban";
import EditCorbanPage from "@/pages/EditCorban";
import { RoleArr } from "@/models/role.model";
import ProposalWrapper from "@/pages/ProposalWrapper";
import ChangePasswordPage from "@/components/ChangePasswordPage";
import ShareLinkPage from "@/components/ShareLinkPage";
import ProposalsPage from "@/components/ProposalsPage";
// import BatchUserRegistrationPage from "@/components/BatchUserRegistrationPage";
import ProductTable from "@/components/ProductTable";
import ProductRegisterForm from "@/components/ProductRegisterForm";
import PromotorasTable from "@/components/PromotorasTable";
import PromotoraRegisterForm from "@/components/RegisterPromotoraForm";
import CreditPromoterDetails from "@/components/CreditPromoterDetails";
import BankAnalysis from "@/components/BankAnalysis/BankAnalysis";
import WhiteLabelTable from "@/components/WhiteLabelAnalysis";
import Finances from "@/pages/Finances";
import FeedbackListPage from "@/components/Feedback";
import DashboardBi from "@/pages/DashboardBi";
import ProposalModal from "@/components/ProposalModal";
import FixProposalModal from "@/components/FixProposalModal";
import ConsignadoProposalsPage from "@/components/consignado/ConsignadoProposalsPage";
import ConsignadoSimulationPage from "@/components/consignado/ConsignadoSimulationPage";
import ConsignadoProductTable from "@/components/consignado/ConsignadoProductTable";
import ConsignadoProductRegisterForm from "@/components/consignado/ConsignadoProductRegisterForm";
import ConsignadoCriterionEngineListPage from "@/components/consignado/ConsignadoCriterionEngineListPage";
import ConsignadoCriterionEngineEditor from "@/components/consignado/ConsignadoCriterionEngineEditor";
import BancoAnalise from "../components/consignado/BancoAnalise";
import ConsignadoEngineConfigTable from "@/components/consignado/ConsignadoEngineConfigTable";
import ConsignadoEngineConfigEditor from "@/components/consignado/ConsignadoEngineConfigEditor";
import ConsigFinances from "@/pages/consignado/ConsigFinances";
import NewsletterPage from "@/components/Newsletter";
import NewsletterEditor from "@/components/NewsletterEditor";
import CreditAuctionProposalsPage from "@/components/CreditAuctionProposalsPage";
import UsersPage from "@/components/UsersTablePage";
import { CobrancaAtivosPage, CobrancaEncerradosPage, CobrancaRelatorioPage } from "@/pages/consignado/Cobranca/cobranca.route";
import WhitelistBlacklistPage from "@/pages/consignado/WhitelistBlacklist";
import ConfigNotificacoesPage from "@/pages/consignado/ConfigNotificacoes";

export interface RouteConfig {
  name: string;
  path: string;
  component: React.ComponentType<any>;
  roles?: RoleArr[];
  exact?: boolean;
  permissions?: string[];
}

export const routes: RouteConfig[] = [
  {
    name: "home",
    path: "/",
    component: Home,
    permissions: ["GRANATECH"],
  },
  {
    name: "link",
    path: "/link",
    component: ShareLinkPage,
    permissions: ["GRANATECH"],
  },

  {
    name: "proposals-page",
    path: "/fgts/propostas",
    component: ProposalsPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "proposals-page-id",
    path: "/fgts/propostas/:id",
    component: ProposalModal,
    permissions: ["GRANATECH"],
  },
  {
    name: "proposals-page-fix",
    path: "/fgts/propostas/:id/fix",
    component: FixProposalModal,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-consult-cpf",
    path: "/consignado/simulacao",
    component: ConsignadoSimulationPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-banco-analise",
    path: "/consignado/banco-analise",
    component: BancoAnalise,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-proposals-page",
    path: "/consignado/propostas",
    component: ConsignadoProposalsPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-product-page",
    path: "/consignado/produtos",
    component: ConsignadoProductTable,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-financial-page",
    path: "/consignado/financeiro",
    component: ConsigFinances,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-product-form",
    path: "/consignado/produtos/:productId",
    component: ConsignadoProductRegisterForm,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-engine-config-table",
    path: "/consignado/engine-config",
    component: ConsignadoEngineConfigTable,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-aprovacao-pj",
    path: "/consignado/aprovacao-pj",
    component: WhitelistBlacklistPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-engine-config",
    path: "/consignado/engine-config/:id",
    component: ConsignadoEngineConfigEditor,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-cobranca-clt",
    path: "/consignado/cobranca",
    component: CobrancaAtivosPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-cobranca-clt-vinculos-encerrados",
    path: "/consignado/cobranca/vinculos-encerrados",
    component: CobrancaEncerradosPage,
    // component: CobrancaVinculosEncerradosConsignado,
    permissions: ["GRANATECH"],
  },
    {
    name: "consignado-cobranca-clt-relatorio",
    path: "/consignado/cobranca/relatorio",
    component: CobrancaRelatorioPage,
    permissions: ["GRANATECH"],
  },
  {
    // O item "Config. Notificações" já existia no menu lateral sem rota
    // correspondente (sobra do revert de agosto); esta rota é o destino dele.
    name: "consignado-config-notificacoes",
    path: "/consignado/config-notificacoes",
    component: ConfigNotificacoesPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-criterios-page",
    path: "/consignado/criterios-credito",
    component: ConsignadoCriterionEngineListPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-criterios-page",
    path: "/consignado/criterios-credito/novo",
    component: ConsignadoCriterionEngineEditor,
    permissions: ["GRANATECH"],
  },
  {
    name: "consignado-criterios-page",
    path: "/consignado/criterios-credito/:criterioId",
    component: ConsignadoCriterionEngineEditor,
    permissions: ["GRANATECH"],
  },
  {
    name: "corban-table",
    path: "/corbans",
    component: CorbansTable,
    permissions: ["GRANATECH"],
  },
  {
    name: "corban-create",
    path: "/corban/adicionar",
    component: CreateCorbanPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "corban-edit",
    path: "/corban/editar/:id",
    component: EditCorbanPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "user-table",
    path: "/users",
    component: UsersPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "user-create",
    path: "/users/create",
    component: UserRegisterForm,
    permissions: ["GRANATECH"],
  },
  // {
  //   name: "user-insert-batch",
  //   path: "/users/batch",
  //   component: BatchUserRegistrationPage,
  //   permissions: ["GRANATECH"],
  // },
  {
    name: "user-edit",
    path: "/users/edit/:id",
    component: UserRegisterForm,
    permissions: ["GRANATECH"],
  },
  {
    name: "proposal-form",
    path: "/proposta/:id",
    component: ProposalWrapper,
    permissions: ["GRANATECH"],
  },
  {
    name: "proposal-link",
    path: "/link/proposta",
    component: ShareLinkPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "change-password",
    path: "/trocar-senha",
    component: ChangePasswordPage,
  },
  {
    name: "financial-page",
    path: "fgts/financeiro",
    component: Finances,
    permissions: ["GRANATECH"],
  },
  {
    name: "dashboard-bi-page",
    path: "/dashboardbi",
    component: DashboardBi,
    permissions: ["GRANATECH"],
  },
  {
    name: "product-page",
    path: "fgts/produtos",
    component: ProductTable,
    permissions: ["GRANATECH"],
  },
  {
    name: "product-form",
    path: "fgts/produtos/:productId",
    component: ProductRegisterForm,
    permissions: ["GRANATECH"],
  },
  {
    name: "promotoras-page",
    path: "/promotoras",
    component: PromotorasTable,
    permissions: ["GRANATECH"],
  },
  {
    name: "promotoras-create",
    path: "/promotoras/create",
    component: PromotoraRegisterForm,
    permissions: ["GRANATECH"],
  },
  {
    name: "promotoras-details",
    path: "/promotoras/:id",
    component: CreditPromoterDetails,
    permissions: ["GRANATECH"],
  },
  {
    name: "analyze-bank",
    path: "fgts/analyze-bank",
    component: BankAnalysis,
    permissions: ["GRANATECH"],
  },
  {
    name: "analyze-whitelabel",
    path: "/analyze-whitelabel",
    component: WhiteLabelTable,
    permissions: ["GRANATECH"],
  },
  {
    name: "feedbacks",
    path: "/feedbacks",
    component: FeedbackListPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "newsletter",
    path: "/newsletter",
    component: NewsletterPage,
    permissions: ["GRANATECH"],
  },
  {
    name: "newsletter-editor",
    path: "/newsletter/:newsletterId",
    component: NewsletterEditor,
    permissions: ["GRANATECH"],
  },
  {
    name: "propostas-leilao-clt",
    path: "/fgts/leilao/propostas",
    component: CreditAuctionProposalsPage,
    permissions: ["GRANATECH"],
  }
];